import React, { useCallback, useEffect, useState } from 'react';
import { Grid2 } from '@mui/material';
import { TMaterialStyles } from '../../theme';
import BackgroundPattern from '../../../assets/patterns/background-pattern.png';
import GameModesCarousel from '../../components/Game/GameModesCarousel/GameModesCarousel';
import { GeneralNavBtn } from '../../components/Game/GeneralNavBtn/GeneralNavBtn';
import { ScreenWrapper } from '../../components/Wrappers/ScreenWrapper';
import { ERoutes } from '../../enums';
import { useNavigate } from 'react-router';
import { getGameModeStatus } from '../../queries';
import { TrainingNavBtn } from '../../components/Game/TrainingNavBtn/TrainingNavBtn';
import { CompetitionNavBtn } from '../../components/Game/CompetitionNavBtn/CompetitionNavBtn';

const GameModesScreen: React.FC = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(ERoutes.main);
  }, [navigate]);

  const loadGameModesStatus = useCallback(async () => {
    try {
      await getGameModeStatus('competitive');
      await getGameModeStatus('general');
    } catch (error: any) {
      console.error('Error while [loadGameModesStatus]', error);
    }
  }, []);

  useEffect(() => {
    loadGameModesStatus();
  }, [loadGameModesStatus]);

  return (
    <ScreenWrapper onBack={handleBack} isAbsolute>
      <Grid2 sx={materialStyles.container}>
        <GameModesCarousel setActiveSlide={setActiveSlide} />
        {activeSlide === 0 && <CompetitionNavBtn />}
        {activeSlide === 1 && <GeneralNavBtn />}
        {activeSlide === 2 && <TrainingNavBtn />}
      </Grid2>
    </ScreenWrapper>
  );
};

const materialStyles: TMaterialStyles = {
  button: {
    m: 1,
    width: '250px',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    backgroundImage: `url(${BackgroundPattern})`,
    backgroundRepeat: 'repeat',
    backgroundSize: '667px 1000px',
  },
  play: {
    width: '131px',
    height: '73px',
    fontFamily: 'Rubber Duck',
    fontSize: '36px',
    borderRadius: '14px',
    mt: '30px',
  },
};

export default GameModesScreen;
